import cn from 'classnames';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { Select, SelectProps } from './';
import styles from './styles.scss';

interface Props extends SelectProps {
  isSelected: boolean;
  label: string;
}

export const LabeledSelect = ({ placeHolder, isSelected, label, disabled, ...props }: Props) => (
  <div
    className={cn(styles.labeledSelect, { [styles.isSelected]: isSelected })}
    {...getQaDataAttr(`DropDown`)}
  >
    <Select disabled={disabled} {...props} />

    <div
      className={cn(
        styles.label,
        { [styles.selected]: isSelected },
        { [styles.disabled]: disabled }
      )}
    >
      {!isSelected && <span className={styles.choose}>{placeHolder}</span>} {label}
    </div>
  </div>
);
